import { getInitData } from './telegram';

const BASE = (import.meta.env.VITE_API_BASE_URL as string) ?? '';

export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string | undefined,
    message: string,
    public details?: unknown,
  ) {
    super(message);
  }
}

async function request<T>(
  method: string,
  path: string,
  body?: unknown,
): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      'X-Telegram-Init-Data': getInitData(),
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  let payload: unknown;
  try {
    payload = await res.json();
  } catch {
    payload = null;
  }

  if (!res.ok) {
    const err = (payload ?? {}) as { error?: string; code?: string; details?: unknown };
    throw new ApiError(
      res.status,
      err.code,
      err.error ?? `HTTP ${res.status}`,
      err.details,
    );
  }
  // Worker отдаёт { data: T } на успех. Если ответ пустой или без data — это
  // значит либо что-то не так с самим API, либо CORS зарезал ответ.
  if (!payload || typeof payload !== 'object') {
    throw new ApiError(res.status, 'EMPTY_RESPONSE', 'Empty response from API');
  }
  if (!('data' in payload)) {
    throw new ApiError(
      res.status,
      'BAD_RESPONSE',
      `Unexpected response shape: ${JSON.stringify(payload).slice(0, 100)}`,
    );
  }
  return (payload as { data: T }).data;
}

export const api = {
  get: <T>(path: string) => request<T>('GET', path),
  post: <T>(path: string, body?: unknown) => request<T>('POST', path, body),
  patch: <T>(path: string, body?: unknown) => request<T>('PATCH', path, body),
  delete: <T>(path: string) => request<T>('DELETE', path),
};

export function apiBase(): string {
  return BASE;
}
